var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.formattedValue))])
}
var staticRenderFns = []

export { render, staticRenderFns }